import type { CommandInfo } from "@opencode-ai/client/promise"

// 服务端把 skill/命令展开成： 模板正文 + "\n\n" + 用户实际输入。
// 这里在展示时把模板正文剥掉，只保留用户真正键入的内容；
// 若用户没有附加输入（只发了 /name），则回退显示 /name。
export function matchSkillDisplay(text: string, commands: CommandInfo[] | undefined): string | undefined {
  if (!commands?.length) return undefined
  const trimmed = text.trimStart()
  let best: { len: number; label: string } | undefined
  for (const c of commands) {
    const tpl = c.template?.trim()
    if (!tpl || tpl.length < 8) continue // 太短的模板跳过，避免误匹配
    if (!trimmed.startsWith(tpl)) continue
    if (best && tpl.length <= best.len) continue // 取最长匹配
    const userInput = trimmed.slice(tpl.length).trim()
    best = { len: tpl.length, label: userInput || `/${c.name}` }
  }
  return best?.label
}
